import { render, staticRenderFns } from "./header.vue?vue&type=template&id=4d8f23bc&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./header.vue?vue&type=style&index=0&id=4d8f23bc&prod&lang=less&scoped=true&"
import style1 from "./header.vue?vue&type=style&index=1&id=4d8f23bc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8f23bc",
  null
  
)

export default component.exports